import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from '@irb/app.service';
import { IrbAppEvents, IrbClientsEvents } from '@irb/irb-common/events';

@Component({ standalone: false,
  selector: 'irb-create-external-accounts-complete-dialog',
  templateUrl: './create-external-accounts-complete-dialog.component.html',
  styleUrls: ['./create-external-accounts-complete-dialog.component.scss']
})
export class CreateExternalAccountsCompleteDialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public mdd: any,
    private as: AppService,
    public dialogRef: MatDialogRef<CreateExternalAccountsCompleteDialogComponent>,
  ) { }

  ngOnInit() {
    console.log('this.mdd', this.mdd);
  }

  close() {
    this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
    this.dialogRef.close();
  }

  gotoAccountDetails(): void {
    this.close();
    this.as.fireEvent(IrbClientsEvents.SHOW_EDIT_ACCOUNT, { data: this.mdd.accountDetails });
  }

}
